// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react' // eslint-disable-line @typescript-eslint/no-unused-vars
import { Button } from '@uswitch/ev-components/lib/components/elements/trustyle-button'
import { connect } from 'react-redux'
import {
  isQueryLoading,
  getESData,
  visualFilterQueryId,
  hits,
} from '../../redux/elasticsearch/elasticsearch-selectors'
import { getData } from '../../redux/elasticsearch/elasticsearch-actions'
import { getPageOffset, getMaxPerPage } from '../../redux/product-tables/product-table-selectors'
import { useComponentTracking } from '../../utils/component-events'

const Pagination = ({
  totalHits,
  maxPerPage,
  pageOffset,
  variant,
  isLoading,
  getData,
  productTableId,
  visualFilterInState,
  data,
}) => {
  const trackComponent = useComponentTracking()

  const overrideQuery = visualFilterInState ? { overrideQueryId: visualFilterInState } : {}
  const handlePaginationClick = () =>
    getData({ pageOffset: pageOffset + maxPerPage, productTableId, ...overrideQuery })

  const loadAmount = Math.min(totalHits - maxPerPage - pageOffset, maxPerPage)

  React.useEffect(() => {
    if (data.length <= maxPerPage) return

    trackComponent('Product Table Event', 'loadMoreClicked', getTrackingData(data, loadAmount))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const getTrackingData = (data, loadAmount) => {
    const productNames = data
      .slice(-maxPerPage)
      .map((i) => i._source?.definition?.display_name)
      .join(';')

    const productIds = data
      .slice(-maxPerPage)
      .map((i) => i._source?.definition?.id)
      .join(';')

    return {
      newProducts: loadAmount,
      productNames,
      productIds,
    }
  }

  return (
    <>
      <If
        condition={
          loadAmount > 0 &&
          variant !== 'Card' &&
          variant !== 'eligibilitySlider' &&
          variant !== 'bestRates' &&
          variant !== 'topPicks' &&
          variant !== 'aboveTheFold' &&
          variant !== 'aboveTheFoldHorizontal'
        }
      >
        <div sx={{ display: 'flex', justifyContent: 'center', marginTop: 'md' }}>
          <Button
            variant='primary'
            onClick={handlePaginationClick}
            disabled={isLoading}
            data-fs-core-product-table-load-more
          >
            {isLoading ? 'Loading' : `Load ${loadAmount} more`}
          </Button>
        </div>
      </If>
    </>
  )
}

const calculateMaxResults = (totalHits, offset, initialMaxPerPage) => {
  if (totalHits > offset + initialMaxPerPage) {
    return initialMaxPerPage
  } else {
    return totalHits - offset
  }
}

const ConnectedPagination = connect(
  (state, props) => {
    const totalHits = getESData(state, props.datasetId)?.hits?.total
    const offset = getPageOffset(state, props.datasetId)
    const initialMaxPerPage = getMaxPerPage(state, props.datasetId)
    const loading = isQueryLoading(state, props.datasetId)
    const max = calculateMaxResults(totalHits, offset, initialMaxPerPage)
    const visualFilterInState = visualFilterQueryId(state)

    const data = hits(state, props.datasetId)

    return {
      ...props,
      isLoading: loading,
      totalHits,
      pageOffset: offset,
      maxPerPage: max,
      visualFilterInState,
      data,
    }
  },
  { getData },
)(Pagination)

export default (props) => <ConnectedPagination {...props} />
